// export const LOCAL_ENV = {
//   MOCK_API: false,
// };
export const SCREEN_WIDTH = {
  MOBILE: 520,
};
export const CONSTS = {
  VER: 'VER',
  ERR: 'ERR',
  OK: 'OK',
  IDEAL_TEXT_LENGTH: 50,

  UNAUTHORIZED_STATUS_CODE: 401,
  EXPIRED_STATUS_CODE: 498,
};

export const REGEX = {
  BRAND_NAME: new RegExp(
    "^[A-Za-z0-9](?!.*[._\\-\\s]{2})[A-Za-z0-9.\\-_\\s&'’!()]{0,98}[A-Za-z0-9.!)]$"
  ),
  PAN: new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/),
  ONLYCHAR: new RegExp(/^[A-Za-z\s]+$/),
  ONLYNUM: new RegExp(/^[0-9]*$/),
  ONLYCHARNUM: new RegExp(/^[A-Za-z0-9\s]+$/),
  LINKS: new RegExp(
    /^(https?:\/\/)(www\.)?[a-zA-Z0-9@:%._\+~#?&//=]{2,256}\.[a-z]{2,6}\b(\/[-a-zA-Z0-9@:%._\+~#?&//=]*)*$/i
  ),
  EMAIL: new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/),
  IFSC: new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/), // SBIN0001234
  ACCOUNT_NO: new RegExp(/^[a-zA-Z0-9]{9,25}$/),
  ACCOUNT_HOLDER_NAME: new RegExp(
    "^(?=.{2,100}$)(?=.*[A-Za-z])[A-Za-z0-9](?:[A-Za-z0-9 .,&'()/-]*[A-Za-z0-9.)])?$"
  ),
  GST: new RegExp(
    /^\d{2}[A-Z]{5}\d{4}[A-Z][A-Z0-9]{3}$|^\d{4}[A-Z]{3}\d{5}[0-9A-Z]{3}$|^\d{2}[A-Z]{4}\d{5}[A-Z][A-Z0-9]{3}$/
  ),
  CIN: new RegExp(
    /^([LUu]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/
  ),
};

export const TOAST_CONFIG = {
  position: 'top-right',
  autoClose: 10000,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  theme: 'colored',
  closeButton: true,
  style: {
    fontSize: '14px',
    top: '1rem',
    right: '1rem',
    minHeight: 'auto',
    margin: '4px 0',
    width: window.innerWidth < 500 ? 'calc(100% - 2rem)' : undefined,
  },
};

// Toast ID constants
export const TOAST_IDS = {
  ERROR: 'error-toast',
  SUCCESS: 'success-toast',
  WARNING: 'warning-toast',
  INFO: 'info-toast',
};